import Button from "../button";

function SuccessModal({ closeSuccessModal, message = "Operación realizada" }) {

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
            onClick={closeSuccessModal} /* Cierra al hacer clic fuera */
        >
            <div
                onClick={(e) =>
                    e.stopPropagation()
                } /* Evita que el clic dentro lo cierre */
            >
                <div className="relative w-[20rem] bg-white p-6 rounded-lg shadow-lg">
                    <button
                        onClick={closeSuccessModal}
                        className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                    >
                        ✕
                    </button>
                    <div className="text-2xl font-bold mb-4 text-center">
                        {message}
                    </div>
                    <div className="flex flex-col justify-center gap-4">
                        <Button
                            variant="secondary"
                            fullWidth
                            onClick={closeSuccessModal}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SuccessModal;
